import React, { Component } from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import classNames from 'classnames';
import ReactSlider from 'react-slider';
import './slider.scss';

class TurnoverSek extends Component {
    
    constructor(props) {
        super(props);
        const qs = queryString.parse(props.location.search);
        this.state = {
            values: [0, props.turnoverClasses.length],
            valueLow: this.parseTurnoverParms(qs[props.param], props.turnoverClasses)[0], 
            valueHigh: this.parseTurnoverParms(qs[props.param], props.turnoverClasses)[1],
            turnoverClasses: props.turnoverClasses    
        };
    
    }

    componentDidMount() {
        const qs = queryString.parse(this.props.location.search);
        this.handleInputBlur(this.parseTurnoverParms(qs[this.props.param], this.props.turnoverClasses)[0], 0);
        this.handleInputBlur(this.parseTurnoverParms(qs[this.props.param], this.props.turnoverClasses)[1], 1);

        if (this.props.registerComponent) {
            this.props.registerComponent(this);
        }

        if (this.props.values) {
            this.setState({
                values:this.props.values,
                valueLow: this.props.turnoverClasses[this.props.values[0]].min, 
                valueHigh: this.props.turnoverClasses[this.props.values[1]-1] && this.props.turnoverClasses[this.props.values[1]-1].max
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { turnoverclass } = this.props;
        if (!this.props.isOpen && turnoverclass !== prevProps.turnoverclass) {
            this.setState({
                turnoverclass: this.props.turnoverclass,
                turnoverClasses: this.props.turnoverClasses
            });
        }
    }

    parseTurnoverParms(queryParam, turnover) {
    
        const defaultValue = [turnover[0].min, turnover[turnover.length-1].max];
        
        if (!queryParam) {
            return defaultValue;
        }

        const paramLowHigh = queryParam.split('-');
        
        if (paramLowHigh.length !== 2) {
            return defaultValue;
        }

        if (!Number.isNaN(paramLowHigh[0] * 1) && !Number.isNaN(paramLowHigh[1] * 1)) {
            return [paramLowHigh[0] * 1, paramLowHigh[1] * 1];
        }

        return defaultValue;
    }
    
    handleChange(values) {

        if (!this.state.turnoverClasses[values[1]-1]) {
            return;
        }

        this.setState({
            values,
            valueLow: this.state.turnoverClasses[values[0]].min,
            valueHigh: this.state.turnoverClasses[values[1]-1].max
        });
    }

    handleInputBlur(value, index) {
        if (!this.state.turnoverClasses) return;
        if (!Number.isNaN(value*1)) {
            let values = this.state.values;
            let valueLow = this.state.valueLow;
            let valueHigh = this.state.valueHigh;
            let turnoverClassIndex = 0;
            for (let classIndex = 0; classIndex < this.state.turnoverClasses.length; classIndex++) {
                if (index === 0) {
                    if (value < this.state.turnoverClasses[classIndex].min) {
                        turnoverClassIndex = classIndex-1;
                        values[0] = turnoverClassIndex;
                        break;
                    }
                }

                if (index === 1) {
                    if (value >= this.state.turnoverClasses[classIndex].min && value <= this.state.turnoverClasses[classIndex].max) {
                        turnoverClassIndex = classIndex+1;
                        values[1] = turnoverClassIndex;
                        break;
                    }
                }
            }

            if (index === 0) {
                if (value > valueHigh) {
                    values[0] = values[1];
                    valueLow = valueHigh;
                }
            }
            
            if (index === 1) {
                if (value < valueLow) {
                    values[1] = values[0];
                    valueHigh = valueLow;
                }
            }
            
            this.setState({
                values,
                valueLow: valueLow < 0 ? 0 : valueLow,
                valueHigh
            }, () => {
                if (this.props.onBlur) {
                    this.props.onBlur({
                        values: this.state.values,
                        valueLow: this.state.valueLow,
                        valueHigh: this.state.valueHigh
                    });
                }
            });
        } else {
            this.setState({
                valueLow: this.state.valueLow,
                valueHigh: this.state.valueHigh
            }, () => {
                if (this.props.onBlur) {
                    this.props.onBlur({
                        values: this.state.values,
                        valueLow: this.state.valueLow,
                        valueHigh: this.state.valueHigh
                    });
                }
            });
        }
    }

    handleInputChangeLow(e) {
        const value = e.currentTarget.value;
        if (!Number.isNaN(value*1)) {
            this.setState({
                valueLow: value
            });
        }
    }

    handleInputChangeHigh(e) {
        const value = e.currentTarget.value;
        if (!Number.isNaN(value*1)) {
            this.setState({
                valueHigh: value
            });
        }
    }

    handleKeyDown(e, index) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleInputBlur(e.currentTarget.value, index);
        }
    }

    sumTurnover(turnoverclass) {
        if (turnoverclass && turnoverclass[0]) {
            return turnoverclass[0].facetValues.reduce((a, {count}) => a + count, 0);
        }

        return 0;
    }

    handleAfterChange() {
        if (this.props.submitForm) {
            this.props.submitForm(null, this.props.param, {
                values: this.state.values,
                valueLow: this.state.valueLow,
                valueHigh: this.state.valueHigh
            });
        }
    }
    
    render() {        

        const { turnoverclass, turnoverClasses } = this.state;
        const total = this.sumTurnover(turnoverclass);

        return (
            <div className={classNames({
                'slider': true,
                ...this.props.modifiers
            })}>
                <span className="slider__caption">{this.props.caption}</span>
                <div className="slider__bars">
                    {turnoverClasses.map(tclass => {
                        const facetItem = turnoverclass && turnoverclass[0] && turnoverclass[0].facetValues.find(item => item.label === tclass.label);
                        return (
                            <div key={`bar${tclass.label}`} className="slider__bar" style={{
                                height: facetItem ? `calc(${(facetItem.count / total) * 100 * 3.5}%)` : '0'
                            }}></div>
                        );
                    })} 
                </div>
                <div className="slider__slider">
                    <ReactSlider
                        className="slider__horizontal"
                        thumbClassName="slider__track-thumb"
                        trackClassName="slider__track"
                        onChange={(val) => this.handleChange(val)}
                        onAfterChange={(val) => this.handleAfterChange(val)}
                        min={0}
                        max={turnoverClasses.length}
                        value={this.state.values}
                        ariaLabel={['Lower thumb', 'Upper thumb']}
                        ariaValuetext={state => `Thumb value ${state.valueNow}`}
                        renderThumb={({className, ...prop}, state) => {
                            return (
                                <div {...prop} className="slider__track-thumb-container"><div className={classNames({
                                    'slider__track-fade': true,
                                    'slider__track-fade--right': state.index === 1
                                })}></div><div className={className}><span className="slider__thumb-grip"></span></div></div>
                            );
                        }}
                        pearling
                        minDistance={1} />
                    <input disabled={this.props.disableFreeText} className="slider__input" type="text" value={this.state.valueLow} onKeyPress={(e) => this.handleKeyDown(e, 0)} onChange={(e) => this.handleInputChangeLow(e)} onBlur={(e) => this.handleInputBlur(e.currentTarget.value, 0)} />
                    <input disabled={this.props.disableFreeText} className="slider__input slider__input--high" type="text" value={this.state.valueHigh} onKeyPress={(e) => this.handleKeyDown(e, 1)} onChange={(e) => this.handleInputChangeHigh(e)} onBlur={(e) => this.handleInputBlur(e.currentTarget.value, 1)} />
                    {(this.state.valueLow !== turnoverClasses[0].min || this.state.valueHigh !== turnoverClasses[turnoverClasses.length-1].max) &&
                        <input type="hidden" name={this.props.param} value={`${this.state.valueLow}-${this.state.valueHigh}`} />
                    }
                </div>
            </div>
        );
    }

    
};

export default withRouter(TurnoverSek);